import React, { useState, useEffect, useRef } from 'react';
import { Container } from 'reactstrap';
import TauriNavigation from '../TauriNavigation/TauriNavigation';
import 'bootstrap/dist/css/bootstrap.min.css';
import TauriSidebar from '../TauriSidebar/TauriSidebar';
import TauriBreadcrumbs from '../TauriBreadcrumbs/TauriBreadcrumbs';
import TauriHostContainer from '../TauriHostContainer/TauriHostContainer';
import './TauriLayout.css';
import config from '../../appURL.json';

const TauriLayout = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [pathBreadcrumbs, setPathBreadcrumbs] = useState([]);
  const [headerPathBreadcrumbs, setHeaderPathBreadcrumbs] = useState([]);
  const [currentPath, setCurrentPath] = useState([]);
  const prevPathBreadcrumbs = useRef([]);
  const prevHeaderPathBreadcrumbs = useRef([]);

  useEffect(() => {
    // Merge the two useEffects into one for clarity
    if (
      JSON.stringify(prevPathBreadcrumbs.current) !== JSON.stringify(pathBreadcrumbs) ||
      JSON.stringify(prevHeaderPathBreadcrumbs.current) !== JSON.stringify(headerPathBreadcrumbs)
    ) {
      // If either pathBreadcrumbs or headerPathBreadcrumbs changed, update currentPath
      setCurrentPath(pathBreadcrumbs.length ? pathBreadcrumbs : headerPathBreadcrumbs);
    }
  }, [pathBreadcrumbs, headerPathBreadcrumbs]);

  const handleHeaderClick = (parent) => {
    setBreadcrumbs(parent);
    setHeaderPathBreadcrumbs(parent.name);
  };

  const handleItemSelected = (parent, name) => {
    setBreadcrumbs(parent);
    setPathBreadcrumbs(name);

    const sidebarMenu = document.getElementById('sidebarMenu');
    if (sidebarMenu && sidebarMenu.classList.contains('show')) {
      sidebarMenu.classList.remove('show');
    }
  };

  return (
    <div className='layout'>
      <TauriNavigation />

      <div className="container-fluid">
        <div className="row">
          <nav id="sidebarMenu" className="col-lg-2 d-lg-block p-0 sidebar collapse">
            <div className="position-sticky">
              <TauriSidebar
                onHeaderClick={handleHeaderClick}
                handleItemClick={handleItemSelected}
              />
            </div>
          </nav>

          <main className="flex-grow-1 col-md-9 col-lg-10 p-0 m-0">
            <TauriBreadcrumbs
              parent={breadcrumbs}
              name={currentPath}
              separator={String.fromCharCode(9658)}
            />
            <div className='host-container' tag="main">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default TauriLayout;
